import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import VirtualizedList from '../../virtualizedList';
import User from './user';
import { isArray, isArrayEmpty } from '../../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    paddingBottom: spacing(4),
  },
  usersViewport: {
    maxHeight: 152,
  },
  userWrapper: {
    borderBottom: `1px solid ${primary.bluish7}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  title: {
    marginBottom: spacing(2),
  },
  scrollY: {
    right: -19,
  },
}));

const Users = ({ title, users = [], survey = null }) => {
  const classes = useStyles();

  const getVirtualUserSize = useCallback(
    index => (index === users.length - 1 ? 24 : 32),
    [users.length]
  );

  const renderUser = useCallback(user => <User user={user} />, []);

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2" className={classes.title}>
        {title}
      </Typography>
      {isArray(users) && !isArrayEmpty(users) ? (
        <div>
          <VirtualizedList
            viewportClass={classes.usersViewport}
            verticalScrollClass={classes.scrollY}
            itemClass={classes.userWrapper}
            items={users}
            count={users.length}
            gap={8}
            estimateSize={getVirtualUserSize}
            renderItem={renderUser}
          />
        </div>
      ) : (
        <Typography variant="subtitle2" component="div">
          {survey?.companyAvatar}
        </Typography>
      )}
    </div>
  );
};

Users.propTypes = {
  title: PropTypes.string.isRequired,
  users: PropTypes.arrayOf(PropTypes.object),
  survey: PropTypes.object,
};

export default Users;
